import { useDynamicPowerPricesEnabledContext } from '../../context/dynamic-power-prices-enabled-provider'
import useIsDynamicEmsAccessible from './use-is-dynamic-ems-accessible'

/**
 * Hook that returns whether the dynamic EMS feature is available for the current installation
 */
const useShouldShowEmsBanner = (): { showEmsBanner: boolean } => {
  const { isDynamicPowerPriceEnabled } = useDynamicPowerPricesEnabledContext()
  const { isDynamicEmsAccessible } = useIsDynamicEmsAccessible()

  return { showEmsBanner: isDynamicPowerPriceEnabled && isDynamicEmsAccessible }
}

export default useShouldShowEmsBanner
